// extracted by mini-css-extract-plugin
export default {"container":"HueJ0P","header":"FcoMfL","notPGLayout":"Ty6mCW","notPgLayout":"Ty6mCW","withPadding":"H3Pr8E","menu":"sOtL8B"};